import React from 'react';
import { NavHashLink } from 'react-router-hash-link';


const Nav = ({ mobile }) => {

    const scrollWithOffset = (el) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = 0; 
        setTimeout(function () {
            window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
        },2);    }

    return (
        <ul className="mainmenu">
            <li >
                <NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/`}>INICIO</NavHashLink>
    
            </li>
            <li className="has-droupdown">
                <NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/conocenos`}>CONÓCENOS</NavHashLink>
                <ul className="submenu">
                    <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/conocenos#section1`}>Historia</NavHashLink></li>
                    <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/conocenos#section2`}>Misión/Visión</NavHashLink></li>
                    <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/conocenos#section3`}>Línea del tiempo</NavHashLink></li>
                    <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/Directorio`}>Directorio</NavHashLink></li>
                    <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/Transparencia`}>Transparencia</NavHashLink></li>
                    <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/politicaprivacidad`}>Política de privacidad</NavHashLink></li>
                    
                </ul>
            </li>

            <li className="has-droupdown">
                <NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/salas`}>VISÍTANOS</NavHashLink>
                <ul className="submenu">
                {/*<li><a href="https://boletos.caracolbc.org" target="_blank" rel="noopener noreferrer">Boletos</a></li> */}
                <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/salas#sectionplanetario`}>Planetario</NavHashLink></li>
                <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/salas#section2`}>Sala de la Tierra</NavHashLink></li>
                <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/salas#section3`}>Sala del Mar</NavHashLink></li>
                <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/salas#section4`}>Sala Temporal</NavHashLink></li>
                </ul>
            </li>
   
            {/*<li className="has-droupdown">
                <NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/salas`}>SALAS</NavHashLink>
                <ul className="submenu">
                    <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/salas#section1`}>Sala del Cielo</NavHashLink></li>
                    <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/salas#section2`}>Sala de la Tierra</NavHashLink></li>
                    <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/salas#section3`}>Sala del Mar</NavHashLink></li>
                </ul>
            </li>
 */}
            <li className="has-droupdown">
            <NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/Educacion`}>DESCUBRE</NavHashLink>
                <ul className="submenu">
                    <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/Educacion`}>Artículos</NavHashLink></li>
                    <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/Recursos`}>Recursos</NavHashLink></li>
                </ul>
            </li>

            <li className="has-droupdown">
            <NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/Colabora`}>DONA</NavHashLink>
                <ul className="submenu">
                <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/Colabora#section2`}>Donativos</NavHashLink></li>
                <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/Colabora#section3`}>Dejando huella</NavHashLink></li>
                <li><NavHashLink scroll={el => scrollWithOffset(el)}  to={process.env.PUBLIC_URL + `/Colabora#section1`}>Membresías</NavHashLink></li>

                </ul>
            </li>
            {mobile && <li><a href="https://boletos.caracolbc.org" target="_blank" rel="noopener noreferrer">BOLETOS</a></li>}
        </ul>
    )
}
export default Nav;
